import React, { Component } from 'react';

import { NavLink } from 'react-router-dom';

class MyAccountNavigation extends Component {
  render() {
    return (
      <div className="in-page-navigation">
        <ul className="my-account-navigation">
          {this.props.menuItems.map((navData, i) => (
            <li key={'my-account-menu-item-' + i}>
              <NavLink to={navData.href}>{navData.text}</NavLink>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default MyAccountNavigation;



// WEBPACK FOOTER //
// ./src/containers/MyAccount/MyAccountNavigation.jsx